import React from "react";
import { SectionHeading } from "./SectionHeading";
import { steps } from "../data/content";
export function BuildSteps() {
  return <section className="bg-white px-4 py-16" aria-labelledby="steps-title" data-id="element-15" data-mp="23xhzefbrs0jp">
      <div className="mx-auto max-w-5xl" data-id="element-16" data-mp="1px76l6qwgbvw">
        <SectionHeading id="steps-title" title="From plan to finished build" accent="Everything follows a simple system" data-id="element-17" data-mp="1q0bk4uq98jz8" />
        <ol className="mt-12 grid gap-x-8 gap-y-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-18" data-mp="1g8pah2tkesyl">
          {steps.map((s, i) => <li key={s.title} className="relative border-t border-neutral-200 pt-6" data-id="element-19" data-mp="1kzfdi9eiqjq4" data-mpi={i}>
              <span className="absolute -top-4 left-0 flex h-8 w-8 items-center justify-center rounded-full bg-brand font-heading text-sm font-bold text-white" data-id="element-20" data-mp="16aj5gccgp6pi">
                {i + 1}
              </span>
              <p className="text-xs font-semibold uppercase text-ink-muted" data-id="element-21" data-mp="x91lujzuimw2">Step {i + 1}</p>
              <h3 className="mt-1 font-heading font-bold uppercase" data-id="element-22" data-mp="128eexmhb8q73">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-muted" data-id="element-23" data-mp="2cn3q3aj2e1w5">{s.text}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}